import React from 'react';

import { Link } from '@gogame/components';

import { useKnowledgeBase } from './KnowledgeBaseContext';

const KnowledgeBaseLink = ({ children, ...props }) => {
  const { knowledgeBaseUrl } = useKnowledgeBase();
  return (
    <Link
      target={'_blank'}
      underline={'none'}
      color={'inherit'}
      {...props}
      href={knowledgeBaseUrl}
    >
      {children}
    </Link>
  );
};

export default KnowledgeBaseLink;
